module.exports = __webpack_public_path__ + "static/1-0fab8ec1d3a79a4f3d8a23ec6e34527c.png";